export function track(event: string, action: string, data: Record<string, unknown>) {
  if (window.gtag) {
    window.gtag(event, action, data)
  }
}
